import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIEndpoint } from 'src/app/models/options/api-endpoint';

@Injectable()
export class WebClientService {

  constructor(
    private http:HttpClient
  ) { }


  get = <T>(
    endpoint: APIEndpoint | string,
    params?: HttpParams | { [param: string]: string | string[] }
  ): Observable<T> => {
    return this.http.get<T>(endpoint, {
      params
    })
  }
  
  head = <T>(
    endpoint: APIEndpoint | string,
    params?: HttpParams | { [param: string]: string | string[] }
  ): Observable<T> => {
    return this.http.head<T>(endpoint, {
      params
    })
  }

  post = <T>(
    endpoint: APIEndpoint | string,
    params?: HttpParams | { [param: string]: string | string[] },
    body?: Object
  ): Observable<T> => {
    return this.http.post<T>(endpoint, body, {
      params,
    })
  }

  put = <T>(
    endpoint: APIEndpoint | string,
    params?: HttpParams | { [param: string]: string | string[] },
    body?: Object
  ): Observable<T> => {
    return this.http.put<T>(endpoint, body, {
      params,
    })
  }

  delete = <T>(
    endpoint: APIEndpoint | string,
    params?: HttpParams | { [param: string]: string | string[] },
  ):Observable<T> =>{
    return this.http.delete<T>(endpoint,{
      params,
    })
  }
}
